<script lang="ts">
	import type { LargeTextData } from '$lib/queries/LargeTextQuery';

	let { data }: { data: LargeTextData } = $props();
</script>

<section>
	<p class="text:h3">{data.text}</p>
	{#if data.buttonLink}
		<a class="button:pill" {...data.buttonLink}>{data.buttonText ?? data.buttonLink.title}</a>
	{/if}
</section>

<style lang="scss">
	section {
		margin: 0;
		display: flex;
		flex-direction: column;
		align-items: start;
		gap: 1em;
		padding: 0 var(--gutter);
		margin-bottom: var(--spacing-auto);

		@include md {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: end;
		}
	}

	p {
		text-wrap: wrap;
		margin: 0;

		@include md {
			text-wrap: balance;
			flex: 0 1 cols(12, 9, false, true);
			max-width: 35em;
		}
	}

	a {
		@include md {
			flex: 0 0 auto;
		}
	}
</style>
